import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { getFormatedCurrency, getOrderHistoryCardBottomView, getOrderHistoryCardView } from "utils/common";

import { Colors } from "colors";
import { FONTS_SIZES } from "fonts";
import ImageView from "../../../src/image";
import { Images } from "assets";
import Markdown from "react-native-markdown-display";
import React from "react";
import VText from "components/VText";

const OrderHistoryCard = ({
    productDetails = {},
    currentSize,
    onPressCard = () => {},
    isCallFromOrderDetail = false,
    isPreparing = false,
    isDelivered = false,
    onPressCancel = () => {},
    onPressReturnPolicy = () => {},
    preorder = {},
    showCancel = false,
    cardStyle = {},
}) => {
    const isAffiliate = productDetails?.affiliateBrandName && productDetails?.affiliateLink ? true : false;

    return (
        <TouchableOpacity
            activeOpacity={0.6}
            onPress={() => {
                onPressCard(productDetails);
            }}
        >
            <View testID="ProductCard" style={[styles.productCard, cardStyle]}>
                {preorder?.showPreorder && (
                    <View>
                        <View
                            style={{
                                paddingHorizontal: 8,
                                paddingVertical: 6,
                                borderWidth: 1,
                                borderColor: "#21242799",
                                borderRadius: 2,
                                backgroundColor: "#FFFFFF",
                                alignSelf: "flex-start",
                                marginBottom: 8,
                            }}
                        >
                            <VText
                                style={{
                                    lineHeight: 8,
                                    fontSize: 8,
                                    fontWeight: "550",
                                    letterSpacing: "3%",
                                    color: "#21242799",
                                }}
                            >
                                PRE ORDER
                            </VText>
                        </View>
                        {preorder?.preorderDateMessage && (
                            <View
                                style={{
                                    marginBottom: 16,
                                }}
                            >
                                <Markdown
                                    style={{
                                        lineHeight: 20,
                                        fontSize: 13,
                                        fontWeight: "350",
                                        color: "#21242799",
                                    }}
                                >
                                    {preorder?.preorderDateMessage}
                                </Markdown>
                            </View>
                        )}
                    </View>
                )}
                {isCallFromOrderDetail ? null : (
                    <View style={[styles.orderStatusView]}>
                        {productDetails?.inStore && (
                            <VText
                                style={{
                                    fontSize: 15,
                                    lineHeight: 24,
                                    color: "#212427",
                                    textDecorationLine: "underline",
                                }}
                            >
                                In-store
                            </VText>
                        )}

                        {!productDetails?.inStore && (
                            <>{getOrderHistoryCardView(productDetails?.status, productDetails, isAffiliate)}</>
                        )}

                        {isCallFromOrderDetail ? null : (
                            <TouchableOpacity
                                onPress={() => onPressCard(productDetails)}
                                style={{ alignContent: "center" }}
                            >
                                <Svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <Path
                                        d="M7.1016 4.16083L14.9496 12.0088L7.1016 19.8568C6.87432 20.0863 6.78673 20.4195 6.87178 20.7308C6.95682 21.0424 7.20151 21.2848 7.51385 21.3669C7.82603 21.449 8.15831 21.3583 8.38559 21.1289L16.8816 12.6449C17.0501 12.4761 17.1448 12.2474 17.1448 12.0089C17.1448 11.7703 17.0501 11.5416 16.8816 11.3728L8.38559 2.88882C8.15832 2.6594 7.82605 2.56873 7.51385 2.65083C7.20152 2.73292 6.95684 2.97533 6.87178 3.28686C6.78673 3.59824 6.87432 3.93147 7.1016 4.16087V4.16083Z"
                                        fill="#212427"
                                        fill-opacity="0.6"
                                    />
                                </Svg>
                            </TouchableOpacity>
                        )}
                    </View>
                )}
                <View style={[styles.flexRow, { marginTop: isCallFromOrderDetail ? 0 : spV(10) }]}>
                    <ImageView
                        source={{
                            uri: productDetails?.imageUrls?.[0],
                            priority: ImageView.priority.high,
                        }}
                        resizeMode={ImageView.resizeMode.contain}
                        style={styles.image}
                    />
                    <View style={styles.productInfo}>
                        <View>
                            <VText style={styles.boldText}>{productDetails?.brandName?.toUpperCase()}</VText>
                            <VText style={[styles.text]} numberOfLines={2}>
                                {productDetails?.productName}
                            </VText>
                            {productDetails?.returnObject?.url !== "" ? (
                                <TouchableOpacity
                                    onPress={onPressReturnPolicy}
                                    style={{
                                        height: spV(32),
                                        borderRadius: 4,
                                        flexDirection: "row",
                                        backgroundColor: "rgba(247, 247, 247, 1)",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        paddingHorizontal: 8,
                                        marginBottom: 9,
                                        alignSelf: "flex-start",
                                    }}
                                >
                                    <VText style={styles.returnText}>{"Return Policy"}</VText>
                                    <ImageView
                                        source={Images.rightArrow}
                                        style={{ width: 13, height: 14, tintColor: Colors.black30 }}
                                    />
                                </TouchableOpacity>
                            ) : (
                                <View
                                    style={{
                                        height: spV(32),
                                        borderRadius: 4,
                                        flexDirection: "row",
                                        backgroundColor: "rgba(247, 247, 247, 1)",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        paddingHorizontal: 8,
                                        marginBottom: 9,
                                        alignSelf: "flex-start",
                                    }}
                                >
                                    <VText style={styles.returnText}>
                                        {`Return policy: ${productDetails?.returnObject?.text}`}
                                    </VText>
                                </View>
                            )}
                            <VText style={[styles.boldText, { marginTop: spV(8) }]}>{`$${getFormatedCurrency(
                                productDetails?.productPrice
                            )}`}</VText>
                        </View>
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            {currentSize && (
                                <VText
                                    style={{
                                        fontSize: fp(14),
                                        fontWeight: "350",
                                    }}
                                >{`Size: ${currentSize}`}</VText>
                            )}
                            <VText
                                style={[
                                    {
                                        fontSize: fp(14),
                                        fontWeight: "350",
                                    },
                                    { paddingLeft: spH(16) },
                                ]}
                            >{`Quantity: ${productDetails?.quantity}`}</VText>
                        </View>
                    </View>
                </View>
                {showCancel &&
                    !isAffiliate &&
                    !productDetails?.inStore &&
                    isCallFromOrderDetail &&
                    (isPreparing || isDelivered) && (
                        <TouchableOpacity
                            onPress={() => {
                                onPressCancel(isPreparing ? "Cancel" : "Return");
                            }}
                            style={styles.cancelBtn}
                        >
                            <VText style={styles.boldBlackText}>{isPreparing ? "Cancel" : "Return"}</VText>
                        </TouchableOpacity>
                    )}
                {getOrderHistoryCardBottomView(productDetails?.status, productDetails, isAffiliate)}
            </View>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    flexRow: {
        flexDirection: "row",
    },
    productCard: {
        backgroundColor: "white",
        justifyContent: "space-between",
        marginBottom: spV(28),
        paddingBottom: spV(24),
        borderBottomWidth: 1,
        borderColor: "rgba(33, 36, 39, 0.16)",
    },
    orderStatusView: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    confirmIcon: {
        width: 24,
        height: 24,
    },
    productInfo: {
        width: "70%",
        marginLeft: spH(10),
    },
    image: {
        width: wp(111),
        height: hp(148),
    },
    dotStyle: {
        width: 10,
        height: 10,
        borderRadius: 5,
        marginHorizontal: 0,
        backgroundColor: "rgba(0, 0, 0, 0.92)",
    },
    subitleStyle: {
        color: Colors.black60,
        marginTop: 4,
        marginBottom: 16,
    },
    titleStyle: {
        marginTop: 4,
    },
    text: {
        fontSize: fp(14),
        fontWeight: "350",
        lineHeight: "140%",
        paddingBottom: spV(4),
        color: "#656565",
    },
    priceText: {
        color: Colors.black,
        fontWeight: "550",
        fontSize: 16,
    },
    textLightBlack: {
        color: Colors.black60,
        lineHeight: 24,
    },
    boldText: {
        fontSize: fp(14),
        fontWeight: "550",
        lineHeight: "140%",
        paddingBottom: spV(4),
    },
    cancelBtn: {
        alignItems: "center",
        justifyContent: "center",
        //width: spH(160),
        height: spV(40),
        marginTop: spV(0),
        borderRadius: 5,
        backgroundColor: Colors.white,
        borderWidth: 1,
        borderColor: Colors.greyBorder,
        // marginTop: 10,
    },
    boldBlackText: {
        color: Colors.black,
        fontWeight: "550",
        fontSize: FONTS_SIZES.s14,
        lineHeight: 20,
    },
    sizeView: {
        alignSelf: "flex-start",
        marginVertical: 4,
        borderWidth: 1,
        borderColor: Colors.greyBorder,
        borderRadius: 4,
        paddingHorizontal: 16,
    },
    icon: {
        width: 15,
        height: 15,
    },
    returnText: {
        fontSize: 12,
        color: Colors.black60,
        fontWeight: "350",
    },
});

export default OrderHistoryCard;
